import styles from "./AppVersion.module.css";

type Props = {
    version?: string;
};

export const AppVersion = ({ version }: Props) => (
    <aside className={styles.version}>{`v. ${version ?? "---"}`}</aside>
);
